import 'what-input';

import './modules/accordions';
import './modules/cookieConsent-configs';
import './modules/number-format';
import './modules/login-panel';
import './modules/mega-menu';
import './modules/mobile-menu';
import './modules/scroll-to-top';
import './modules/forms';
import './modules/search-panel';
import './modules/swipers';
import './modules/countdown-timer';
import './modules/auto-suggest';

// MicroModal est charge globalement par TypoScript : on active ici la liaison
// des declencheurs data-micromodal-trigger et le verrouillage du defilement.
MicroModal.init({ disableScroll: true });

// Module import exemple with Code Splitting
// const AModule = () => import(/* webpackChunkName: "a-module"*/ './modules/AModule');
